import dayjs from 'dayjs';
import React, { useContext } from 'react';

import { Context } from 'components/hoc/Store';
import { RowTitles } from 'components/molecules/RowTitles';

interface IOdeslaniPozadavkuRows {
    idSluzby?: number;
    datum?: string;
}

const OdeslaniPozadavkuRows: React.FC<IOdeslaniPozadavkuRows> = ({ idSluzby, datum }) => {
    const { mePozadavkyBisign } = useContext(Context);

    return (
        <div>
            <RowTitles firstText="ID" secondText={String(idSluzby || mePozadavkyBisign?.sluzba)} />
            <RowTitles
                firstText="DATUM"
                secondText={dayjs(datum || mePozadavkyBisign?.datum).format('DD.MM.YYYY HH:mm:ss')}
            />
        </div>
    );
};

export default OdeslaniPozadavkuRows;
